// Bell sounds collection with durations
import bellMp3 from './bell.mp3'; // Import the MP3 file directly

const bellSounds = {
  standard: {
    name: 'Standard School Bell',
    sound: bellMp3,
    duration: '0:03'
  },
  digital: {
    name: 'Digital Electronic Bell',
    sound: bellMp3,
    duration: '0:02'
  },
  classic: {
    name: 'Classic Hand Bell',
    sound: bellMp3,
    duration: '0:04'
  },
  modern: {
    name: 'Modern School Bell',
    sound: bellMp3,
    duration: '0:03'
  },
  cheerful: {
    name: 'Cheerful Chime Bell',
    sound: bellMp3,
    duration: '0:02'
  }
};

export default bellSounds;
